import { filterTokenByIntegrationId } from '@shared/helpers';

export const saveSearchDetails = props => {
  return {
    type: 'SET_SEARCH_DETAIL',
    payload: props,
  };
};

export const saveSearchAssistDetails = props => {
  return {
    type: 'SET_SEARCH_ASSIST_DETAIL',
    payload: props,
  };
};

export const saveQuoteSelected = props => {
  return {
    type: 'SET_QUOTE_SELECTED',
    payload: props,
  };
};

export const saveHotelDetails = props => {
  const { tokens, ...rest } = props;

  const token = filterTokenByIntegrationId(tokens, rest.idIntegration);

  return {
    type: 'SET_HOTEL_DETAIL',
    payload: { ...rest, ...token },
  };
};

export const updateHotelFormikValuesStep1 = newCF => ({
  type: 'UPDATE_HOTEL_FORMIK_VALUES_STEP1',
  payload: newCF,
});

export const updateHotelFormikValuesStep2 = newCF => ({
  type: 'UPDATE_HOTEL_FORMIK_VALUES_STEP2',
  payload: newCF,
});

export const saveVoucherInfo = props => {
  return {
    type: 'SET_VOUCHER_INFO',
    payload: props,
  };
};

export const onUserLogin = props => {
  return {
    type: 'ON_USER_LOGIN',
    payload: props,
  };
};

export const refreshToken = props => {
  return {
    type: 'REFRESH_TOKEN',
    payload: props,
  };
};

export const onUserLogout = props => {
  return {
    type: 'ON_USER_LOGOUT',
    payload: props,
  };
};

export const setPageConfigurations = props => {
  return {
    type: 'SET_PAGE_CONFIGURATION',
    payload: props,
  };
};

export const setDetailTransaction = props => {
  return {
    type: 'SET_DETAIL_TRANSACTION',
    payload: props,
  };
};

export const saveSearchOneWay = props => {
  return {
    type: 'SET_SEARCH_FLIGHTS_ONEWAY',
    payload: props,
  };
};

export const saveSearchRoundTrip = props => {
  return {
    type: 'SET_SEARCH_FLIGHTS_ROUNDTRIP',
    payload: props,
  };
};

export const saveSearchMultipleDestination = props => {
  return {
    type: 'SET_SEARCH_FLIGHTS_MULTIPLEDESTINATION',
    payload: props,
  };
};

export const saveSearchBody = props => {
  return {
    type: 'SET_SEARCH_FLIGHTS_BODY',
    payload: props,
  };
};

export const saveIsThreeDaysSearch = props => {
  return {
    type: 'SET_IS_THREE_DAYS_SEARCH',
    payload: props,
  };
};

export const setSearchFlightsType = props => {
  return {
    type: 'SET_SEARCH_FLIGHTS_TYPE',
    payload: props,
  };
};

export const setSearchFlightsResult = props => {
  return {
    type: 'SET_SEARCH_FLIGHTS_RESULT',
    payload: props,
  };
};

export const setIsNewSearch = props => {
  return {
    type: 'SET_IS_NEW_SEARCH',
    payload: props,
  };
};

export const setSearchLink = props => {
  return {
    type: 'SET_SEARCH_LINK',
    payload: props,
  };
};

export const setFFranquicia = props => {
  return {
    type: 'SET_FFRANQUICIA',
    payload: props,
  };
};

export const setFormPassengers = props => {
  return {
    type: 'SET_FORMPASSENGERS',
    payload: props,
  };
};
export const setPersonalizedSearch = props => {
  return {
    type: 'SET_PERSONALIZED_SEARCH',
    payload: props,
  };
};

export const setFormNoViaja = props => {
  return {
    type: 'SET_FORMNOVIAJA',
    payload: props,
  };
};

export const setPersonalizedIndex = props => {
  return {
    type: 'SET_PERSONALIZED_INDEX',
    payload: props,
  };
};

export const setFormContact = props => {
  return {
    type: 'SET_FORM_CONTACT',
    payload: props,
  };
};

export const setAssistEmitedData = props => {
  return {
    type: 'SET_ASSISTEMITEDDATA',
    payload: props,
  };
};

export const setTabTouch = props => {
  return {
    type: 'SET_TAB_TOUCH',
    payload: props,
  };
};

export const setIntegrations = props => {
  return {
    type: 'SET_INTEGRATIONS',
    payload: props,
  };
};

export const setProviders = props => {
  return {
    type: 'SET_PROVIDERS',
    payload: props,
  };
};

export const setProvidersPriority = priorities => ({
  type: 'SET_PROVIDERS_PRIORITY',
  payload: priorities,
});

export const setSharedSearch = payload => ({
  type: 'SET_SHARED_SEARCH',
  payload,
});

export const setSearchFlights = payload => ({
  type: 'SET_SEARCH_FLIGHTS',
  payload,
});

export const resetSearchFlights = ({
  trip_type,
  shouldReset = false,
  searchPax,
  flightClass,
  airSectionRow,
}) => ({
  type: 'RESET_SEARCH_FLIGHTS',
  payload: { trip_type, shouldReset, searchPax, flightClass, airSectionRow },
});
//?! VALIDATE PRICE
export const setValidationHotelPriceAlert = props => {
  return {
    type: 'SET_VALIDATION_HOTEL_PRICE_ALERT',
    payload: props,
  };
};
//?! VALIDATE PRICE
